import { render, staticRenderFns } from "./User.Detail.vue?vue&type=template&id=452e36e1&"
import script from "./User.Detail.vue?vue&type=script&lang=js&"
export * from "./User.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports